/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M11.9999 6H15.9999C16.3099 6 16.4649 6 16.5921 6.03407C16.9372 6.12654 17.2067 6.39609 17.2992 6.74118C17.3333 6.86835 17.3333 7.02334 17.3333 7.33333V7.33333V8M11.9999 6H9.99991M11.9999 6V8.5M11.9999 18H14.6666M11.9999 18H9.33325M11.9999 18V12M5.99976 6L17.9998 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M12.0002 6H16.0002C16.7365 6 17.3335 6.59695 17.3335 7.33333V7.33333V8M12.0002 6H10.0002M12.0002 6V8.5M12.0002 18H14.6668M12.0002 18H9.3335M12.0002 18V12M6 6L18 18M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM16 6.75C16.1618 6.75 16.2581 6.75018 16.3305 6.75348C16.376 6.75556 16.3956 6.75838 16.4005 6.75918C16.4848 6.78268 16.5506 6.84856 16.5741 6.93286C16.5749 6.9377 16.5778 6.95733 16.5799 7.00287C16.5832 7.07521 16.5833 7.17154 16.5833 7.33333V8C16.5833 8.41421 16.9191 8.75 17.3333 8.75C17.7475 8.75 18.0833 8.41421 18.0833 8V7.33333L18.0834 7.26922V7.2692C18.0839 7.02663 18.0844 6.7736 18.0237 6.54707C17.8619 5.94316 17.3902 5.47145 16.7863 5.30963C16.5597 5.24893 16.3067 5.24943 16.0641 5.24991L16 5.25H12H9.99999C9.58578 5.25 9.24999 5.58579 9.24999 6C9.24999 6.41421 9.58578 6.75 9.99999 6.75H11.25V8.5C11.25 8.91421 11.5858 9.25 12 9.25C12.4142 9.25 12.75 8.91421 12.75 8.5V6.75H16ZM6.53017 5.46967C6.23727 5.17678 5.7624 5.17678 5.46951 5.46967C5.17661 5.76256 5.17661 6.23744 5.46951 6.53033L11.25 12.3108V17.25H9.33333C8.91912 17.25 8.58333 17.5858 8.58333 18C8.58333 18.4142 8.91912 18.75 9.33333 18.75H12H14.6667C15.0809 18.75 15.4167 18.4142 15.4167 18C15.4167 17.5858 15.0809 17.25 14.6667 17.25H12.75V13.8108L17.4695 18.5303C17.7624 18.8232 18.2373 18.8232 18.5302 18.5303C18.8231 18.2374 18.8231 17.7626 18.5302 17.4697L12.5396 11.4791C12.5335 11.4728 12.5272 11.4665 12.5209 11.4604L6.53017 5.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M12.0002 6H16.0002C16.7365 6 17.3335 6.59695 17.3335 7.33333V7.33333V8M12.0002 6H10.0002M12.0002 6V8.5M12.0002 18H14.6668M12.0002 18H9.3335M12.0002 18V12M6 6L18 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12.0002 6H16.0002C16.7365 6 17.3335 6.59695 17.3335 7.33333V7.33333V8M12.0002 6H10.0002M12.0002 6V8.5M12.0002 18H14.6668M12.0002 18H9.3335M12.0002 18V12M6 6L18 18M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.3304 6.75341C16.258 6.75011 16.1617 6.74993 15.9999 6.74993H12.7499V8.49993C12.7499 8.91414 12.4141 9.24993 11.9999 9.24993C11.5857 9.24993 11.2499 8.91414 11.2499 8.49993V6.74993H9.99991C9.58569 6.74993 9.24991 6.41414 9.24991 5.99993C9.24991 5.58571 9.58569 5.24993 9.99991 5.24993H11.9999H15.9999C16.0212 5.24993 16.0426 5.24988 16.064 5.24984C16.3066 5.24936 16.5596 5.24886 16.7862 5.30956C17.3901 5.47137 17.8618 5.94308 18.0236 6.54699C18.0843 6.77354 18.0838 7.02658 18.0833 7.26915C18.0833 7.29061 18.0833 7.31199 18.0833 7.33326V7.99993C18.0833 8.41414 17.7475 8.74993 17.3333 8.74993C16.919 8.74993 16.5833 8.41414 16.5833 7.99993V7.33326C16.5833 7.17147 16.5831 7.07514 16.5798 7.00279C16.5777 6.95726 16.5749 6.93763 16.5741 6.93278C16.5506 6.84849 16.4847 6.78261 16.4004 6.75911C16.3955 6.75831 16.3759 6.75548 16.3304 6.75341ZM5.46943 5.4696C5.76232 5.1767 6.23719 5.1767 6.53009 5.4696L12.5208 11.4603C12.5272 11.4665 12.5334 11.4727 12.5395 11.479L18.5301 17.4696C18.823 17.7625 18.823 18.2374 18.5301 18.5303C18.2372 18.8232 17.7623 18.8232 17.4694 18.5303L12.7499 13.8108V17.2499H14.6666C15.0808 17.2499 15.4166 17.5857 15.4166 17.9999C15.4166 18.4141 15.0808 18.7499 14.6666 18.7499H11.9999H9.33325C8.91904 18.7499 8.58325 18.4141 8.58325 17.9999C8.58325 17.5857 8.91904 17.2499 9.33325 17.2499H11.2499V12.3108L5.46943 6.53026C5.17653 6.23736 5.17653 5.76249 5.46943 5.4696Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
